export default {
  title: {
    it: 'Errore di rete',
    de: 'Netzwerkfehler',
    fr: 'Erreur réseau',
    en: 'Network error'
  },

  text: {
    it: 'Controlla la tua connessione internet.',
    de: 'Bitte überprüfe deine Internetverbindung.',
    fr: 'Veuillez vérifier votre connexion internet.',
    en: 'Please check your internet connection.'
  },

  button: {
    it: 'Fatto',
    de: 'Fertig',
    fr: 'Terminé',
    en: 'Done'
  }
};
